<script lang="ts" setup>
defineProps({
	isActive: {
		type: Boolean,
		default: false,
	},
	isUnderline: {
		type: Boolean,
		default: false,
	},
})
const emit = defineEmits(['click'])
</script>

<template>
	<div class="bs-tab" @click="emit('click')">
		<div
			class="bs-tab-inner"
			:class="{ 'bs-tab-inner--underline': isUnderline }"
		>
			<slot />
		</div>
	</div>
</template>
